<script setup>
defineProps({
  interactive: { type: Boolean, default: false },
  padding: { type: String, default: '1rem' },
})
</script>

<template>
  <div
    class="content-block"
    :class="{ 'is-interactive': interactive }"
    :style="{ padding }"
  >
    <slot />
  </div>
</template>

<style scoped>
.content-block {
  background: var(--surface-card);
  border-radius: var(--radius-xl);
  overflow: hidden;
  transition: var(--transition-fast);
}

.content-block.is-interactive {
  cursor: pointer;
}

.content-block.is-interactive:hover {
  background: var(--surface-overlay-2);
}
</style>
